import React, { useEffect, useState, useCallback, useRef } from 'react';
import { Link, useParams, useHistory } from 'react-router-dom';
import moment from 'moment';
import Swal from 'sweetalert2';
import "react-datepicker/dist/react-datepicker.css";

import useUserStore from '../../stores/Users';
import LoadingView from '../../components/Loading';
import axios from 'axios';
import { baseAPI } from '../../services/baseAPI';

function BroadcastList() {
  const history = useHistory();
  const token = useUserStore((state) => state.token);
  const user = useUserStore((state) => state.user);

  const [isLoading, setIsLoading] = useState(true);
  const [dataNotif, setDataNotif] = useState();


  // CONTROLLER
  const fetchDataNotif = async (userId) => {

    await baseAPI
      .get(`/v1/notification/${userId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const data = res.data.data.notifAll.data
        setDataNotif(data)
        setIsLoading(false)
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(`error ${error}`);
      })
  };

  // Update isRead notification (from 1 -> 0), if success it will redirect to ShowBroadcast page
  const handleItemClick = (id) => {
    baseAPI
      .put(`/v1/notification/isread/${id}`, null, {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        fetchDataNotif(user.id);
        history.push(`/broadcast/${id}`);
      })
      .catch((error) => {
        setIsLoading(false);
        console.log('error: ', error);
        Swal.fire({
          icon: 'error',
          title: "Failed show the broadcast.",
          showConfirmButton: false,
          timer: 1500
        })
      })
      .finally(() => {
        refreshPage()
        setIsLoading(false)
        fetchDataNotif(user.id);
      })
  };

  const refreshPage = () => {
    window.location.reload();
  };

  useEffect(() => {
      fetchDataNotif(user.id);
  }, [token]);

  // VIEW

  const headerView = () => (
    <div className='page-header'>
      <div className='row align-items-center'>
        {/* Title */}
        <div className='col'>
          <ol className='breadcrumb'>
            <Link to='/broadcastlist' style={{ color: '#333' }}>List Broadcast</Link>
          </ol>
        </div>
      </div>
    </div>
  );

  const addView = () => (
    <div className='row row-deck row-cards'>
      <div className='col-md-12'>
        <div className='card'>
          <div className='card-body'>
            <div className='row'>
              <div className='mb-2'>
                <p style={{fontSize: 25}}><b>List Broadcast</b></p>
                <p>Broadcast pada list akan terhapus setelah 2 bulan diterima oleh pengguna.</p>
              </div>
              {dataNotif &&
                dataNotif.map((e, index) => (
                <div class="row align-items-center" key={index} onClick={() => handleItemClick(e.id)}>
                  <div class="row align-items-center" key={index}>
                    <div class="col">
                      <div class={`alert ${e.isRead == 1 ? 'alert-success' : 'alert-secondary'}`} role="alert" style={{backgroundColor: e.isRead == 1 ? "#d4edda" : "#f8f9fa"}}>
                        <div class="col text-truncate">
                          <h4 class="alert-title">
                            {e.title}
                          </h4>
                          <div class="d-block text-secondary text-truncate mt-n1">
                            <p style={{marginBottom: 0}}>{moment(e.updated_at).format("DD/MM/yyyy HH:mm")} - {e.role_name}</p>
                            {e.body}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

    </div>
  )

  return (
    <div className='container-fluid'>
      
      {headerView()}
      
      {isLoading ? <LoadingView /> : addView()}

    </div>
  );

}

export default BroadcastList;